import React from "react";
import moment from "moment-timezone";
import { TippedIcon } from "components/Shared";
export const notProvided = "Not Provided";
export const notAvailable = "N/A";

export const dateToStringYy = (dt) => {
  return dateFormatter(dt, "MM/DD/YY");
};

export const dateToStringFileFormat = (dt) => {
  return dateFormatter(dt, "YYYYMMDD");
};

export const dateToString = (dt) => {
  return dateFormatter(dt, "MM/DD/YYYY");
};

export const dateTimeToString = (dt) => {
  return dateFormatter(dt, "MM/DD/YYYY h:mm A");
};

export const dateTimeToStringWithDOW = (dt) => {
  return dateFormatter(dt, "ddd MM/DD/YY h:mm A");
};

export const dateTimeToStringWithSeconds = (dt) => {
  return dateFormatter(dt, "ddd MM/DD/YY h:mm:ss A");
};

export const dateToStringWithDOW = (dt) => {
  return dateFormatter(dt, "ddd MM/DD/YY");
};

export const dateTimeToTime = (dt) => {
  return dateFormatter(dt, "h:mm A");
};

export const dateFormatterBefore1969 = (dt, fmt) => {
  let dateString = notProvided;
  if (dt && dt.length > 0) {
    const momentDate = moment(dt);
    if (!momentDate.isValid()) {
      return notProvided;
    }
    const year = momentDate.year();
    if (year <= 1000) {
      dateString = notProvided;
    } else {
      dateString = momentDate.format(fmt || "MM/DD/YYYY");
    }
  }
  return dateString;
};

export const formatPercent = (p) => {
  return (p || p === 0) ? `${parseFloat(p).toFixed(2)}%` : null;
};

export const formatPercentWholeNumber = (p) => {
  return (p || p === 0) ? `${parseFloat(p).toFixed()}%` : null;
};

export const formatDecimalPercent = p => (p || p === 0) ? (parseFloat(p) * 100).toFixed(2) : null;

/** 
 * Create a percent formatter for a floating point number (i.e. 0.5 === "50%")
 * @returns a new formatter function using the supplied arguments 
 */
export const formatDecimalPercent2 = (decimalPlaces = 2, percentSign = true) => { return p => (p || p === 0) ? `${(parseFloat(p) * 100).toFixed(decimalPlaces)}${percentSign ? "%" : ""}` : null; };

export const dateTimeToStringWithNumOfDays = (dt, dateFormatter = dateToStringWithDOW) => {
  if (!dt) return "";
  let now = moment(new Date());
  let end;

  if (typeof dt === "string")
    end = moment(new Date(dt.substring(0, 4), dt.substring(5, 7) - 1, dt.substring(8, 10)));
  else
    end = moment(dt);

  let numOfDays = Math.trunc(moment.duration(now.diff(end)).asDays());
  let date = dateFormatter(dt);
  if (numOfDays === 0) {
    return date + ` (Today)`;
  } else if (numOfDays > 0) {
    return numOfDays === 1 ? date + ` (${numOfDays} day ago)` : date + ` (${numOfDays} days ago)`;
  } else {
    numOfDays *= -1;
    return numOfDays === 1 ? date + ` (in ${numOfDays} day)` : date + ` (in ${numOfDays} days)`;
  }
};


/** @description: formats a date time as a relatve moment description ex: moments ago, 5 minutes ago, 7 months ago  */
export const dateTimeToStringMomentFromNow = (dt) => {
  if (!dt) return `${dt}`;
  if (!dt.fromNow) {
    dt = moment(dt);
  }
  return dt.fromNow();
};

export const booleanToYesNo = bool => bool ? "Yes" : "No";

export const moneyFormatter = (decimalPlaces) => (num) => {
  if (!decimalPlaces && decimalPlaces !== 0) decimalPlaces = 2;
  if (num !== null && !isNaN(num)){ 
    let numVal = num;
    if (typeof num === "string" && num.length) {
      numVal = Number(num);
    }
    return "$ " + numVal.toFixed(decimalPlaces).replace(/\d(?=(\d{3})+(?!\d))/g, "$&,");
  }
};

export const numberWithCommasFormatter = num => parseFloat(num).toLocaleString("en");

export const dateFormatter = (dt, fmt) => {
  let dateString = "";
  if ((typeof dt === "string" && dt && dt.length > 0) || dt instanceof Date) {
    // Use moment for all date operations since format strings are moment-style
    const momentDate = moment(dt);
    if (!momentDate.isValid()) {
      return dt;
    }
    const year = momentDate.year();
    if (year <= 1969) {
      dateString = "";
    } else {
      dateString = momentDate.format(fmt);
    }
  }

  if (dateString.toLocaleLowerCase() === "invalid date") {
    dateString = dt;
  }
  return dateString;
};

export const checkIfEmpty = (valToCheck, emptyVal, className) => {
  if (valToCheck && valToCheck.length) return valToCheck;
  if (className) return <span className={className}>{emptyVal ? emptyVal : "N/A"}</span>;
  return emptyVal ? emptyVal : "N/A";
};

export const phoneNumberFormatter = (phoneNumber) => {

  if (!phoneNumber || !phoneNumber.length) {
    return "N/A";
  }
  else if (phoneNumber.length < 10 || phoneNumber.length > 11) {
    return "Invalid Format";
  }
  else if (phoneNumber.length === 11) {
    return (phoneNumber[0] + "-" + "(" + phoneNumber.substr(1, 3) + ") " + phoneNumber.substr(4, 3) + "-" + phoneNumber.substr(7, 4));
  }
  else {
    return ("(" + phoneNumber.substr(0, 3) + ") " + phoneNumber.substr(3, 3) + "-" + phoneNumber.substr(6, 4));
  }
};

export const initialCase = (s) => {
  if (typeof s !== "string") return "";
  return s.split(" ").map(s => s.charAt(0).toUpperCase() + s.substring(1).toLowerCase()).join(" ");
};

export const GetDisplayFieldValue = (col, id) => {
  let c = col?.find(item => {
    return item.id === id;
  });

  return !c ? undefined : c.value;
};

export const Capitalize = (input) => {
  return input.replace(/(?:^|\s)\S/g, l => l.toUpperCase());
};

export const commaFormat = (input) => {
  return input.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const lowerCaseTrim = (input) => {
  if (Array.isArray(input))
    return input.map(value => {
      return lowerCaseTrim(value);
    });
  return input.toLowerCase().trim();
};

export const reactMultiSelectGetSelectedValues = (selectedObjects) => {
  return selectedObjects.map(selectedObject => {
    return lowerCaseTrim(selectedObject.value);
  });
};

///Input: Array
///Output: Array unique keys order by count descending
export const arrayRemoveDuplicatesOrderByCount = (array) => {
  if (Array.isArray(array)) {
    return [...new Set(array)]
      .sort((sortElementA, sortElementB) => {
        return array.filter(e => deepCompare(e, sortElementB)).length - array.filter(e => deepCompare(e, sortElementA)).length;
      });
  }
};

export const deepCompare = (a, b) => {
  return JSON.stringify(a) === JSON.stringify(b);
};

export const arrayRemoveDuplicateKeysIncludeCount = (array) => {
  if (Array.isArray(array)) {
    return [...new Set(array)]
      .map(uniqueKey => {
        return {
          key: uniqueKey,
          count: array.filter(element => element === uniqueKey).length,
        };
      });
  }
};

export const emailHyperlink = (email) => {
  return <a href={"mailto: " + email}>{email}</a>;
};

export const mapAddressHyperlink = (address) => {
  return <a href={"http://maps.google.com/?q=" + address} target="_blank">{address}</a>;
};

export const mapCountyHyperlink = (countyState) => {
  const addressComponents = countyState.split("/");
  const county = addressComponents[0];
  const state = addressComponents[1];
  return <a href={"http://maps.google.com/?q=" + county + " county, " + state} target="_blank">{county}</a>;

};

export const mapGeocodeHyperlink = (geocode) => {
  return <a href={"https://www.google.com/maps/search/?api=1&query=" + geocode} target="_blank">{geocode}</a>;
};

export const appraiserFormatter = (appraiser) => {
  if (!appraiser) return null;
  let appraiserInfo = appraiser.split("/");
  let appraiserName = appraiserInfo[0];
  let allowsEdits = appraiserInfo[1] === "true";
  let accountFeatures = appraiserInfo[2] === "true";
  return (
    <div>
      <span style={{ paddingRight: "10px" }}>{appraiserName}</span>
      <TippedIcon
        iconName="edit"
        tooltipText={allowsEdits ? "Edit Data: Opt in" : "Edit Data: Opt out"}
        iconClassName={allowsEdits ? "opt-in-edits" : "no-opt-in-edits"}
        tooltipPopoutDirection="top"
      />
      {accountFeatures &&
        <TippedIcon
          iconName="info"
          tooltipText={"Customer requirements may limit assignment"}
          iconClassName={"no-opt-in-edits"}
          tooltipPopoutDirection="top"
        />}
    </div>
  );
};

export const makeHyperlink = (label, onClick) => {
  if (typeof (onClick) === "string") {
    return <a href={onClick} target="_blank" style={{ cursor: "pointer" }}>{label}</a>;
  } else if (typeof (onClick) === "function") {
    return <a onClick={onClick} tabIndex="0" style={{ cursor: "pointer" }}>{label}</a>;
  }
  return <span>{label}</span>;
};

export const numberToLabel = ({ count, label }) => (
  `${count} ${label}${count === 1 ? "" : "s"}`
);

export const buildURI = (uri, token) => encodeURI(
  uri.includes("mueller")
    ? `${uri}${uri.includes("?") ? "&" : "?"}SSO=${token}`
    : uri,
  "_blank"
);

export const getFileExtension = name => name.substr(name.lastIndexOf(".") + 1).toLowerCase();

export const canPreviewExtension = name => ["pdf", "jpg", "jpeg", "png", "gif"].includes(getFileExtension(name));

//https://www.regextester.com/98583
export const phoneRegExp = /^(1\s?)?((\([0-9]{3}\))|[0-9]{3})[\s\-]?[\0-9]{3}[\s\-]?[0-9]{4}$/;

export const stripSearchParam = searchParam => searchParam.substr(1);

export const stripNonNumeric = s => s.replace(/[^\d]/g, "");
